import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BillingRoutingModule } from './billing-routing.module';
import { TransactionsModule } from './transactions/transactions.module';
import { InvoicesModule } from './invoices/invoices.module';
import { PaymentsModule } from './payments/payments.module';
import { BillingReportModule } from './billing-report/billing-report.module';
import { BillingShellComponent } from './billing-shell/billing-shell.component';

@NgModule({
  imports: [
    CommonModule,
    BillingRoutingModule,
    TransactionsModule,
    InvoicesModule,
    PaymentsModule,
    BillingReportModule,
  ],
  declarations: [BillingShellComponent],
})
export class BillingModule {}
